// Module
var code = "<svg width=\"16.4\" height=\"14\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.4 14\"><path d=\"M.1 14c-.1 0-.1 0 0 0C.5 11.3 1.5 9.1 3 7.4c1.7-2 4-3.3 6.9-3.7V0v-.1h.1l6.2 6.5v.1L10 13h-.1V9.2C5.4 9.3 2.3 10.8.1 14\"/></svg>";
// Exports
export default code;